module.exports = __webpack_public_path__ + "static/shoe-layers-2-99db85e0aed41ac6af3c5007e90fbd8c.png";